<h2 mat-dialog-title>Confirm {{ actionTitle }}</h2>

<mat-dialog-content *ngIf="confirmationData; else confirmWarning" class="confirm">
    <label for="confirmation-value">
        In order to delete
        <span class="text-bold">{{ display }}</span>
        , please input the
        <span class="text-bold">{{ confirmationData.confirmLabel }}</span>
    </label>
    <div>{{ confirmationData.confirmValue }}</div>
    <div class="input-wrapper">
        <mat-form-field appearance="outline">
            <input
                [(ngModel)]="confirmationText"
                type="text"
                id="confirmation-value"
                matInput
                [placeholder]="confirmationData.confirmLabel + ' confirmation'"
            />
        </mat-form-field>
    </div>
</mat-dialog-content>

<ng-template #confirmWarning>
    <mat-dialog-content class="entity-obj" [innerHTML]="dialogContent"> </mat-dialog-content>
</ng-template>

<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="" i18n="@@SHARED.BTN.CANCEL">Cancel</button>
    <button mat-raised-button color="warn" [disabled]="!isAbleToConfirm" [mat-dialog-close]="confirmationActionData">
        {{ actionTitle }}
    </button>
</mat-dialog-actions>
